// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Xr-z","breadcrumbForward":"Yr-z","breadcrumbBack":"Zr-z","selected":"_r-z"};